import { tv, type VariantProps } from "@ui/lib/tv";
import { Fragment } from "react";

const infoPill = tv({
  defaultVariants: {
    width: "hug",
  },
  slots: {
    root: "inline-flex items-center overflow-hidden rounded-full bg-neutral-50",
    segment: "whitespace-nowrap px-4 py-1.5 text-base font-semibold lg:py-2 lg:text-lg",
    label: "text-neutral-300",
    value: "text-neutral-500",
    divider: "w-1 self-stretch bg-white",
  },
  variants: {
    width: {
      fill: {
        root: "flex w-full",
        segment: "flex-1 text-center",
      },
      hug: {},
      responsive: {
        root: "flex w-full md:inline-flex md:w-auto",
        segment: "flex-1 text-center md:flex-none md:text-left",
      },
    },
  },
});

type InfoPillVariants = VariantProps<typeof infoPill>;

export interface InfoPillItem {
  label: string;
  value: string;
}

export interface InfoPillProps {
  className?: string;
  items: InfoPillItem[];
  width?: InfoPillVariants["width"];
}

export function InfoPill({ className, items, width }: InfoPillProps) {
  const styles = infoPill({ width });

  return (
    <div className={styles.root({ className })}>
      {items.map((item, index) => (
        <Fragment key={item.label}>
          {index > 0 && <div className={styles.divider()} />}
          <p className={styles.segment()}>
            <span className={styles.label()}>{item.label} </span>
            <span className={styles.value()}>{item.value}</span>
          </p>
        </Fragment>
      ))}
    </div>
  );
}
